function CampaignPublishedSuccessModalController(
    $scope,
    $uibModalInstance,
    LocalisationService,
    launchDate) {

    var self = this;

    /**
     * Initialises the component
     */
    self.initialise = function () {
        $scope.launchDate = LocalisationService.formatDateLong(launchDate);
    };

    /**
     * Close the modal and return true to the caller
     */
    $scope.Confirm = function () {
        $uibModalInstance.close();
    };

    self.initialise();
}

angular
    .module('dashboard')
    .controller('CampaignPublishedSuccessModalController', [
        '$scope',
        '$uibModalInstance',
        'LocalisationService',
        'launchDate',
        CampaignPublishedSuccessModalController]);
